<template>
    <div class="page-table scrollable only-y mainDiv">
        <div class="page-header card-base card-shadow--small"
             style="height: 0; margin-bottom: 10px; padding: 12px 24px 24px;">
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top: 0">
                <el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.firma.title")}}</el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.firma.yonetici.liste.title")}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="card-base baslikBg animated fadeInUp">Aktif Yöneticiler</div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp">
            <el-table
                    :data="aktifYoneticiList"
                    style="width: 100%">
                <el-table-column
                        label="Sıra"
                        type="index"
                        :index="indexMethod">
                </el-table-column>
                <el-table-column
                        prop="adSoyad"
                        label="İsim Soyisim"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="gorev"
                        label="Görev"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="cepTelefon"
                        label="Telefon"
                        width="auto">
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="auto">
                    <template slot-scope="scope">
                        <el-tooltip :content='$t("src.views.apps.firma.yonetici.liste.yoneticidetay")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-on:click="yoneticiDetay(scope.row)"
                                    type="info"
                                    size="mini"
                                    icon="mdi mdi-information-variant">
                            </el-button>
                        </el-tooltip>
                        &nbsp;
                        <router-link :to="{ path:'/firma/yoneticiGuncelle?yonetimKodu='+scope.row.yonetimKodu}">
                            <el-tooltip :content='$t("src.views.apps.firma.yonetici.liste.yoneticiduzenle")'
                                        :open-delay="500"
                                        placement="bottom">
                                <el-button
                                        v-if="root"
                                        type="warning"
                                        size="mini"
                                        icon="el-icon-edit">
                                </el-button>
                            </el-tooltip>
                        </router-link>
                        &nbsp;
                        <el-tooltip :content='$t("src.views.apps.firma.yonetici.liste.yoneticikaldir")'
                                    :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    class="durdurBtn"
                                    @click="deleteDialogVisible = true; selection = scope.row; selectionIndex = scope.$index"
                                    size="mini"
                                    type="danger"
                                    icon="mdi mdi-pause">
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="card-base kaldirilmis animated fadeInUp delay-1s">Pasif Yöneticiler</div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp delay-2s">
            <el-table
                    :data="pasifYoneticiList"
                    style="width: 100%">
                <el-table-column
                        label="Sıra"
                        type="index"
                        :index="indexMethod">
                </el-table-column>
                <el-table-column
                        prop="adSoyad"
                        label="İsim Soyisim"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="gorev"
                        label="Görev"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="cepTelefon"
                        label="Telefon"
                        width="auto">
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="auto">
                    <template slot-scope="scope">
                        <el-tooltip :content='$t("src.views.apps.firma.yonetici.liste.yoneticidetay")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-on:click="yoneticiDetay(scope.row)"
                                    type="info"
                                    size="mini"
                                    icon="mdi mdi-information-variant">
                            </el-button>
                        </el-tooltip>
                        &nbsp;
                        <router-link :to="{ path:'/firma/yoneticiGuncelle?yonetimKodu='+scope.row.yonetimKodu}">
                            <el-tooltip :content='$t("src.views.apps.firma.yonetici.liste.yoneticiduzenle")'
                                        :open-delay="500"
                                        placement="bottom">
                                <el-button
                                        v-if="root"
                                        type="warning"
                                        size="mini"
                                        icon="el-icon-edit">
                                </el-button>
                            </el-tooltip>
                        </router-link>
                        &nbsp;
                        <el-tooltip :content='$t("src.views.apps.firma.yonetici.liste.yoneticiaktif")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    @click="yoneticiDurumChange(scope.row, scope.$index, pasifYoneticiList,1);"
                                    size="mini"
                                    type="primary"
                                    icon="mdi mdi-play">
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <user-dialog :dialogvisible.sync="dialogVisibleYonetici" :userdata="userdata"></user-dialog>
        <el-dialog
                :title='$t("src.views.apps.firma.yonetici.liste.uyari")'
                :visible.sync="deleteDialogVisible"
                width="30%"
                center>
            <span>"{{selection.adSoyad}}" {{$t('src.views.apps.firma.yonetici.liste.yoneticisil')}}</span>
            <span slot="footer" class="dialog-footer">
        <el-button icon="el-icon-check"
                   type="success"
                   size="mini"
                   @click="yoneticiDurumChange(selection,selectionIndex,aktifYoneticiList,0), deleteDialogVisible = false"></el-button>
        <el-button size="mini" type="danger" icon="el-icon-close"
                   @click="deleteDialogVisible = false"></el-button>
        </span>
        </el-dialog>
    </div>
</template>

<script>
    import yoneticiService from '../../../WSProvider/YoneticiService'
    import UserDialog from '@/components/UserDialog'

    import status from '../../../status'


    let base64 = require('base64_js');
    let userDataArtdoor = "";
    export default {
        name: "YoneticiListesi",
        mounted() {
            let state = false;
            if (localStorage.getItem("userDataArtdoor")) {
                userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
                if (userDataArtdoor["tur"]) {
                    if (userDataArtdoor["tur"] === '1'){
                        state = true;
                        this.root = true;
                    }
                }
                if (userDataArtdoor["tur"]) {
                    if (userDataArtdoor["tur"] === '1' || userDataArtdoor["tur"] === '2')
                        state = true;
                }
            }
            if (!state) {
                this.$store.commit('setLogout');
                this.$router.push("/login");
            } else {
                this.getYoneticiList();
            }
        },
        components: {
            UserDialog,
        },
        data() {
            return {
                search: {
                    baslik: ''
                },
                search2: {
                    baslik: ''
                },
                root:false,
                dialogVisibleYonetici: false,
                userdata: {},
                visibleSil: false,
                visibleEdit: false,
                deleteDialogVisible: false,
                arsivDialogVisible: false,
                selection: '',
                selectionIndex: '',
                aktifYoneticiList: [],
                pasifYoneticiList: [],
            }
        },
        methods: {
            indexMethod(index) {
                return index + 1;
            },
            // handleSizeChange(val) {
            //     this.sizes = val;
            //     this.getYoneticiList(this.postPageAktif, this.sizes, 1);
            // },
            // handleSizeChangePasif(val) {
            //     this.sizes1 = val;
            //     this.getYoneticiList(this.postPagePasif, this.sizes1, 0);
            // },
            yoneticiDetay(scope) {
                this.userdata = scope;
                this.dialogVisibleYonetici = true;
            },
            getYoneticiList() {
                let self = this;
                yoneticiService.yoneticiList().then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            if (e.durum === '0') {
                                self.pasifYoneticiList.push(e);
                            } else if (e.durum === '1') {
                                self.aktifYoneticiList.push(e);
                            }
                        });
                    } else {
                        status.Status(response.status, this)
                    }
                    // switch (response.status) {
                    //     case 200:
                    //         response.data.forEach(function (e) {
                    //             if (e.durum === '0') {
                    //                 self.pasifYoneticiList.push(e);
                    //             } else if (e.durum === '1') {
                    //                 self.aktifYoneticiList.push(e);
                    //             }
                    //         });
                    //         break;
                    //     case 150:
                    //         status.Status('info', this);
                    //         break;
                    //     case 400:
                    //         status.Status('error400', this);
                    //         break;
                    //     case 503:
                    //         status.Status('error', this);
                    //         break;
                    // }
                });
            },
            yoneticiDurumChange(selection, index, list, durum) {
                yoneticiService.yoneticiDurumGuncelle(selection.yonetimId, durum).then((response) => {
                    if (response.status === 200) {
                        switch (durum) {
                            case 0:
                                this.pasifYoneticiList.push(selection);
                                list.splice(index, 1);
                                status.Status('success', this, 'Yönetici başarıyla silindi.');
                                break;
                            case 1:
                                this.aktifYoneticiList.push(selection);
                                list.splice(index, 1);
                                status.Status('success', this, 'Yönetici başarıyla eklendi.');
                                break;
                        }
                    } else {
                        status.Status(response.status, this)
                    }
                    // switch (response.status) {
                    //     case 200:
                    //         switch (durum) {
                    //             case 0:
                    //                 this.pasifYoneticiList.push(selection);
                    //                 list.splice(index, 1);
                    //                 status.Status('success', this, 'Yönetici başarıyla silindi.');
                    //                 break;
                    //             case 1:
                    //                 this.aktifYoneticiList.push(selection);
                    //                 list.splice(index, 1);
                    //                 status.Status('success', this, 'Yönetici başarıyla eklendi.');
                    //                 break;
                    //         }
                    //         break;
                    //     case 100:
                    //         status.Status('warning', this, 'Bu işlem için yetkiniz bulunmamaktadır!!');
                    //         break;
                    //     case 150:
                    //         status.Status('info', this);
                    //         break;
                    //     case 400:
                    //         status.Status('error400', this);
                    //         break;
                    //     case 503:
                    //         status.Status('error', this);
                    //         break;
                    // }
                })
            },
        }
    }

</script>


<style lang="scss" scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }

    .kaldirilmis {
        background: #ec205f;
        color: white;
        font-weight: bold;
        font-size: 16px;
        padding: 10px
    }

</style>
